import { useTranslation } from 'react-i18next'
import { BackButton } from './buttons'
import { useAddendumModal } from './context'
import ListBase from './list-base'
import ModalBase from './modal-base'

const CustomList = () => {
  const { t } = useTranslation()
  const { backStep, customAddendums, setCustomAddendums, customSelected, setCustomSelected } =
    useAddendumModal()

  return (
    <ModalBase
      leftWidget={<BackButton back={backStep} />}
      title={t('l.contract.edit.custom_addendum_modal.title', 'Addendums by your company')}
      subtitle={t(
        'l.contract.edit.custom_addendums_description.text',
        'Here are addendum templates created by your company admins. Click into each one to view details. (Only admins can edit the templates.)'
      )}
    >
      <ListBase
        templates={customAddendums}
        setTemplates={setCustomAddendums}
        selected={customSelected}
        setSelected={setCustomSelected}
        isCustomList
      />
    </ModalBase>
  )
}

export default CustomList
